const LINK_LABELS: Record<string, string> = {
  static_invite_link: 'Public Borrower Invite Link',
};

export interface UserLinkRecord {
  id: string;
  label: string;
  url: string;
}

/**
 * Maps an API payload such as `{ "static_invite_link": "https://..." }` into store records.
 */
export function userLinksResponseToRecords(
  res: Record<string, unknown> | null | undefined,
): UserLinkRecord[] {
  if (!res || typeof res !== 'object') {
    return [];
  }

  const records: UserLinkRecord[] = [];
  for (const [key, value] of Object.entries(res)) {
    if (value == null || value === '' || typeof value !== 'string') {
      continue;
    }

    records.push({
      id: key,
      label: LINK_LABELS[key] ?? formatLinkKeyLabel(key),
      url: value,
    });
  }
  return records;
}

function formatLinkKeyLabel(key: string): string {
  return key
    .split('_')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
